import axios from "axios";
import { domain } from "../../Links/Links";

export async function requestToExtractProducts(setProductsData) {
    const response = await axios.get(domain + '/extract_products/', {
        withCredentials: true,
    })

    if (response.data) {
        setProductsData(response.data);
    }
}